module.exports = __webpack_public_path__ + "static/media/hdgz.c63a485b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/hdgz.png
// module id = 1759
// module chunks = 0 1